import React, { useState, ReactElement, useEffect } from "react";
import Timer from "../../Qbank/PlayQuiz/Components/Timer";
import { BsPencil } from "react-icons/bs";
import "./VerifyOtpForm.scss";

export default function VerifyOtpForm({ handleOtpSubmit, handleClose, data }) {
  const [timeOver, setTimeOver] = useState<boolean>(false);

  function keyUpFn(currentElement, nextElement) {
    if (currentElement.value.length >= 1) {
      nextElement.focus();
      nextElement.select();
    }
  }
  useEffect(() => {
    let boxes: HTMLInputElement[] = Array.from(document.querySelectorAll(".otp_box"));

    for (let i = 0; i < boxes.length; i++) {
      if (i < boxes.length - 1) {
        boxes[i].addEventListener("keyup", () => keyUpFn(boxes[i], boxes[i + 1]));
      }
    }
    return () => {
      for (let i = 0; i < boxes.length; i++) {
        if (i < boxes.length - 1) {
          boxes[i].removeEventListener("keyup", () => keyUpFn(boxes[i], boxes[i + 1]));
        }
      }
    };
  }, []);

  const handleTimeOver = () => {
    setTimeOver(true);
  };
  const handleOtpResend = () => {
    setTimeOver(false);
  };

  const handleOtp = () => {};

  let numberInOtp: number = 4;

  const renderOtpBoxes = () => {
    let otpBoxes: ReactElement<HTMLElement, any>[] = [];
    for (let i = 0; i < numberInOtp; i++) {
      otpBoxes.push(<input maxLength={1} key={i} type="string" id={`otp${i}`} name={`otp${i}`} className="otp_box" />);
    }
    return otpBoxes;
  };
  return (
    <div className="otp_form_container">
      <h3>Verify OTP</h3>
      <p className="otp_description">Enter the 4 digit OTP sent on phone</p>
      <div className="email_container">
        <p id="email">
          {data.phone}
          <span className="edit_email_button" onClick={handleClose}>
            {<BsPencil />}
          </span>
        </p>
      </div>
      <div className="otp_container">
        <form>{renderOtpBoxes()}</form>
      </div>
      <div className="resend_text">
        Resend OTP in <Timer maxTime={20} handleTimeOver={handleTimeOver} hideHours />
      </div>

      <button className="button button_primary" onClick={timeOver ? handleOtpResend : handleOtp}>
        {timeOver ? "Resend OTP" : "Verify OTP"}
      </button>

      <p className="trouble_link">Having troubel? React us on help@aayata.com.np</p>
    </div>
  );
}
